'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'font-awesome';
var width = 512;
var height = 512;
var aliases = [62501,62694,"font-awesome-flag","font-awesome-logo-full"];
var unicode = 'f2b4';
var svgPathData = ['M48 112l0 320 421.6 0c5.7 0 10.4-4.7 10.4-10.4 0-1.5-.3-2.9-.9-4.2L417.4 278.5c-1.8-4.1-1.8-8.9 0-13l61.7-138.9c.6-1.3 .9-2.8 .9-4.2 0-5.7-4.7-10.4-10.4-10.4L48 112z', 'M102.8 56a38.8 38.8 0 1 0 -77.5 0 38.8 38.8 0 1 0 77.5 0zM32 512l0-410C17.5 91.8 8 75 8 56 8 25.1 33.1 0 64 0s56 25.1 56 56c0 15.7-6.4 29.8-16.8 40l366.4 0c14.6 0 26.4 11.8 26.4 26.4 0 3.7-.8 7.3-2.3 10.7-7.3-3.2-7.3-3.2 0 0l-61.7 138.9 61.7 138.9 0 0c1.5 3.4 2.3 7 2.3 10.7 0 14.6-11.8 26.4-26.4 26.4l-421.6 0 0 64-16 0zm16-80l421.6 0c5.7 0 10.4-4.7 10.4-10.4 0-1.5-.3-2.9-.9-4.2L417.4 278.5c-1.8-4.1-1.8-8.9 0-13l61.7-138.9c.6-1.3 .9-2.8 .9-4.2 0-5.7-4.7-10.4-10.4-10.4L48 112 48 432z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFontAwesome = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;